import {put, takeLatest} from 'redux-saga/effects';
import trackingActions, {EVENT_ACTION, EVENT_CATEGORY} from '../../actions/tracking.actions';
import {
    activeUsersActions,
    activeUsersOverviewActions,
    averagePlayTimeActions,
    gamesActions,
    returnPlayersActions,
    exportActions,
    lifetimePlaysActions,
    myOverallHighlightsActions,
    myTopPerformingGamesActions,
    myTop10GamesActions
} from '../../actions/fortnite-game';
import {TrackingEventTypes} from 'epic-diesel-common/src/constants/Tracking';

const interactionTypesMap = {
    [gamesActions.TYPES.GET_GAMES_FAILED]: 'GamesList',
    [activeUsersActions.TYPES.GET_ACTIVE_USERS_FAILED]: 'TotalActiveUsersGraph',
    [activeUsersOverviewActions.TYPES.GET_ACTIVE_USERS_OVERVIEW_FAILED]: 'ActiveUsersOverview',
    [averagePlayTimeActions.TYPES.GET_AVERAGE_PLAY_TIME_FAILED]: 'AveragePlayTimeGraph',
    [returnPlayersActions.TYPES.GET_RETURN_PLAYERS_FAILED]: 'ReturnPlayersGraph',
    [lifetimePlaysActions.TYPES.GET_LIFETIME_PLAYS_FAILED]: 'TotalLifetimePlaysGraph',
    [exportActions.TYPES.PDF_EXPORT_ERROR]: 'PDFExport',
    [exportActions.TYPES.CSV_EXPORT_ERROR]: 'CSVExport',
    [myOverallHighlightsActions.TYPES.GET_HIGHLIGHTS_FAILED]: 'MyOverallHighlightsSidebarPanel',
    [myTopPerformingGamesActions.TYPES.GET_TOP_PERFORMING_GAMES_FAILED]:
        'MyTopPerformingGamesSidebarPanel',
    [myTop10GamesActions.TYPES.GET_TOP_10_GAMES_FAILED]: 'MyTop10GamesSidebarPanel'
};

function* trackAPIError({payload, type}) {
    const {response} = payload || {};

    if (response) {
        const {config, status, data} = response;

        yield put(
            trackingActions.trackCustomEvent({
                eventCategory: EVENT_CATEGORY.FortniteGames,
                eventAction: EVENT_ACTION.Error,
                eventType: TrackingEventTypes.PageView,
                interactionType: interactionTypesMap[type],
                data: {
                    status,
                    errorCode: data.errorCode,
                    errorMessage: data.errorMessage,
                    params: JSON.stringify(config.params)
                }
            })
        );
    }
}

function* trackExportError({type}) {
    yield put(
        trackingActions.trackCustomEvent({
            eventCategory: EVENT_CATEGORY.FortniteGames,
            eventAction: EVENT_ACTION.Error,
            interactionType: interactionTypesMap[type],
            eventType: TrackingEventTypes.PageView
        })
    );
}

function* trackFGErrorsSaga() {
    yield takeLatest(
        [
            gamesActions.TYPES.GET_GAMES_FAILED,
            activeUsersActions.TYPES.GET_ACTIVE_USERS_FAILED,
            activeUsersOverviewActions.TYPES.GET_ACTIVE_USERS_OVERVIEW_FAILED,
            averagePlayTimeActions.TYPES.GET_AVERAGE_PLAY_TIME_FAILED,
            returnPlayersActions.TYPES.GET_RETURN_PLAYERS_FAILED,
            lifetimePlaysActions.TYPES.GET_LIFETIME_PLAYS_FAILED,
            myOverallHighlightsActions.TYPES.GET_HIGHLIGHTS_FAILED,
            myTopPerformingGamesActions.TYPES.GET_TOP_PERFORMING_GAMES_FAILED,
            myTop10GamesActions.TYPES.GET_TOP_10_GAMES_FAILED
        ],
        trackAPIError
    );
    yield takeLatest(
        [exportActions.TYPES.PDF_EXPORT_ERROR, exportActions.TYPES.CSV_EXPORT_ERROR],
        trackExportError
    );
}

export default trackFGErrorsSaga;
